import React, { FC, memo } from "react";

import { Icon } from "@/components/Icon";
import { Text } from "@/components/Text";
import { Flex, Tooltip } from "@/eworkitComponents";

export interface IProgressItemProps {
  children?: JSX.Element;
  title: string;
  completed: boolean;
  text?: string;
  tooltip?: string;
}

export const ProgressItem: FC<IProgressItemProps> = memo(({ children, completed, text, title, tooltip }) => {
  const color = completed ? "grey1" : "black";

  return (
    <Flex padding={["sm", false]} justify="space-between" border={[false, false, true, false]}>
      <Text color={color}>{title}</Text>
      <Flex innerMargin="md">
        {text && (
          <Text weight={completed ? undefined : "bold"} color={color}>
            {text}
          </Text>
        )}
        {children}
        {tooltip && (
          <Tooltip content={tooltip}>
            <Flex align="center">
              <Icon icon="info" size="md" color="grey4" />
            </Flex>
          </Tooltip>
        )}
      </Flex>
    </Flex>
  );
});
